import TextArea, { TextAreaProps } from './TextArea'

export default TextArea

export { TextArea, type TextAreaProps }
